import React from 'react';
import { createStackNavigator } from '@react-navigation/stack';

import { MessagesStackParamList } from '@/types/navigation';
import MessagesScreen from '@/screens/messages/MessagesScreen';
import ConversationScreen from '@/screens/messages/ConversationScreen';
import NewConversationScreen from '@/screens/messages/NewConversationScreen';
import DirectoryScreen from '@/screens/directory/DirectoryScreen';
import { colors, font } from '@/theme/chalkCourt';

const Stack = createStackNavigator<MessagesStackParamList>();

/**
 * Messages tab stack: list → conversation thread → new-conversation picker.
 */
const MessagesNavigator: React.FC = () => (
  <Stack.Navigator
    screenOptions={{
      headerStyle: { backgroundColor: colors.bg, shadowColor: 'transparent' },
      headerTintColor: colors.ink,
      headerTitleStyle: { fontFamily: font.displayBold, fontSize: 20 },
      headerBackTitleVisible: false,
      cardStyle: { backgroundColor: colors.bg },
    }}>
    <Stack.Screen name="MessagesHome" component={MessagesScreen} options={{ headerShown: false }} />
    <Stack.Screen
      name="Conversation"
      component={ConversationScreen}
      options={{ title: 'Conversation' }}
    />
    <Stack.Screen
      name="NewConversation"
      component={NewConversationScreen}
      options={{ title: 'New Conversation' }}
    />
    <Stack.Screen name="Directory" component={DirectoryScreen} options={{ title: 'Staff Directory' }} />
  </Stack.Navigator>
);

export default MessagesNavigator;
